import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Grid, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Button from '../layout/SvgButton';
import { resendVerificationEmail } from '../../actions/auth';

const EmailNotVerifiedNotice = ({
    resendVerificationEmail,
    auth: { user },
}) => {
    const [sending, setSending] = React.useState(false);
    const onResend = async () => {
        if (sending) return;
        setSending(true);
        try {
            await resendVerificationEmail();
        } finally {
            setSending(false);
        }
    };

    return (
        <>
            <Grid
                container
                item
                className={'activationPending'}
                direction={{ xs: 'column', md: 'row' }}
                size={{ xs: 12 }}
                sx={{
                    backgroundColor: 'rgba(0,0,0,0.35)',
                    padding: '16px',
                    margin: '4px',
                    color: 'var(--light-color)',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'relative',
                    backgroundImage:
                        'repeating-linear-gradient(45deg,     rgba(255,255,255,0.03) 5px,    rgba(255,255,255,.03) 15px,    transparent 15px,    transparent 30px)',
                    border: '4px dashed var(--primary-color)',
                    opacity: '0.9',
                }}
            >
                <Grid
                    container
                    flexDirection="row"
                    sx={{
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        justifyContent: 'center',
                    }}
                >
                    <Grid
                        item
                        className="warningIcon"
                        style={{
                            color: 'var(--primary-color)',
                            zIndex: '5',
                            margin: '0 8px 0 0 ',
                        }}
                    >
                        <WarningAmberIcon />
                    </Grid>
                    <Grid item>
                        <Typography
                            component="p"
                            sx={{
                                textAlign: 'center',
                                color: 'var(--primary-color)',
                                textWrap: 'balance',
                            }}
                        >
                            {user && user.email ? (
                                <>
                                    We sent a verification link to{' '}
                                    <span
                                        style={{
                                            color: 'var(--light-color)',
                                            opacity: 0.8,
                                        }}
                                    >
                                        {user.email}
                                    </span>
                                    . Please click the link in the email to
                                    verify your email address to unlock your
                                    account and continue.
                                </>
                            ) : (
                                'Please verify your email address to continue.'
                            )}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid
                    item
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '10px',
                    }}
                >
                    <Button
                        btnwidth="250"
                        onClick={onResend}
                        disabled={sending}
                    >
                        {sending ? 'Sending…' : 'Resend Verification Email'}
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};

EmailNotVerifiedNotice.propTypes = {
    resendVerificationEmail: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({ auth: state.auth });

export default connect(mapStateToProps, { resendVerificationEmail })(
    EmailNotVerifiedNotice
);
